import { render, staticRenderFns } from "./CancelPaymentButton.vue?vue&type=template&id=eb85a1c8&"
import script from "./CancelPaymentButton.vue?vue&type=script&lang=ts&"
export * from "./CancelPaymentButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports